import styled from 'styled-components'

import { H2 } from '@/local/components'

import { Stack } from '@mui/material'

interface Props {
  text: string
  value: string | number
  testId?: string
}

export function Header(props: Props) {
  const { text, value, testId } = props

  return (
    <Stack
      direction="row"
      height="24px"
      flexWrap="nowrap"
      alignItems="center"
      data-testid={testId}
      data-trackid={testId}
      width="100%"
    >
      <H2 ellipsis>{text}</H2>
      <UnShrinkableBlock>
        <H2 style={{ paddingLeft: 6 }} textAlign="right">
          {value}
        </H2>
      </UnShrinkableBlock>
    </Stack>
  )
}

const UnShrinkableBlock = styled.div`
  flex: 0 0 auto;
  width: auto;
`

UnShrinkableBlock.displayName = 'UnShrinkableBlock'
